export default "__VITE_ASSET__rsvmd9CP__"